import AboutUs from "../AboutUs";

function LosPistolerosAboutUs() {
  return (
    <AboutUs
      className="LP-about"
      titleKey="losPistoleros.about.title"
      textKey="losPistoleros.about.text"
    />
  );
}

export default LosPistolerosAboutUs;
